import React, { Component } from "react";
import ReactDOM from "react-dom";
import PropTypes from "prop-types";

import Link from "components/shared/Link/Link";

import FacebookLogin from "react-facebook-login";
import { GoogleLogin } from "react-google-login";

import {
  FACEBOOK_APP_ID_LIVE,
  GOOGLE_APP_ID_LIVE,
  ENABLE_LOGIN_HOME,
  ENABLE_FACEBOOK_LOGIN,
  ENABLE_GOOGLE_LOGIN,
  ENABLE_LOGIN_TOPBAR
} from "config";
import localize from "lang/localize";

import "./Login.css";

const propTypes = {
  topbarlessBackButtonRoute: PropTypes.string,
  language: PropTypes.string,
  /* OAuth */
  responseFacebook: PropTypes.func.isRequired,
  responseFacebookError: PropTypes.func.isRequired,
  responseGoogle: PropTypes.func.isRequired,
  responseGoogleError: PropTypes.func.isRequired
};

class LoginSSOPage extends Component {
  constructor() {
    super();
    this.recaptchaRef = React.createRef();
  }

  /* set class on .component-container for specifically styling this page */
  componentDidMount() {
    let body = ReactDOM.findDOMNode(this).parentNode; // .component-container

    if (!body.classList.contains("loginPage")) {
      body.className += " loginPage";
    }
  }

  /* remove loginPage class on .component-container */
  componentWillUnmount() {
    let body = ReactDOM.findDOMNode(this).parentNode; // .component-container

    if (body.classList.contains("loginPage")) {
      body.classList.remove("loginPage");
    }
  }

  renderTopbarlessBackButton() {
    if (ENABLE_LOGIN_HOME && !ENABLE_LOGIN_TOPBAR) {
      return (
        <div className="pure-u-1-1">
          <Link
            className="topbarless-back-button"
            to={this.props.topbarlessBackButtonRoute}
          >
            <i className="fas fa-arrow-left" />
          </Link>
        </div>
      );
    } else {
      return null;
    }
  }

  renderFacebookLoginButton() {
    if (ENABLE_FACEBOOK_LOGIN) {
      return (
        <div className="pure-u-1-1 horizontalpadding-5">
          <FacebookLogin
            appId={FACEBOOK_APP_ID_LIVE}
            autoLoad={false}
            fields="name,email,picture"
            scope="email"
            callback={this.props.responseFacebook}
            onFailure={this.props.responseFacebookError}
            cssClass={"button button-fb fullwidth"}
            textButton={localize(
              "button_facebook_gametize",
              this.props.language
            )}
            icon="fas fa-facebook"
            isMobile={false}
          />
        </div>
      );
    } else {
      return null;
    }
  }

  renderGoogleLoginButton() {
    if (ENABLE_GOOGLE_LOGIN) {
      return (
        <div className="pure-u-1-1 horizontalpadding-5">
          <GoogleLogin
            clientId={GOOGLE_APP_ID_LIVE}
            onSuccess={this.props.responseGoogle}
            onFailure={this.props.responseGoogleError}
            cookiePolicy={"single_host_origin"}
            autoLoad={false}
            render={renderProps => (
              <button
                className="button button-google fullwidth"
                onClick={renderProps.onClick}
              >
                <i className="fab fa-google" aria-hidden="true" />
                {localize("button_google_gametize", this.props.language)}
              </button>
            )}
          />
        </div>
      );
    } else {
      return null;
    }
  }

  render() {
    return (
      <div className="login-register-container container verticalpadding">
        <div
          className={
            "innerblock pure-g box-sizing-border-box-all" +
            (ENABLE_LOGIN_HOME && !ENABLE_LOGIN_TOPBAR ? " topmargin-20" : "")
          }
        >
          {this.renderTopbarlessBackButton()}
          <div className="pure-u-sm-4-24 pure-u-md-6-24" />
          <div className="pure-u-1 pure-u-sm-16-24 pure-u-md-1-2">
            <div className="pure-g">
              <div className="pure-u-1-1">
                <p className="bottommargin textcenter">
                  <strong>
                    {localize("login_view_sign_in_start", this.props.language)}
                  </strong>
                </p>
              </div>
              {this.renderFacebookLoginButton()}
              {this.renderGoogleLoginButton()}
            </div>
          </div>
          <div className="pure-u-sm-4-24 pure-u-md-6-24" />
        </div>
      </div>
    );
  }
}

LoginSSOPage.propTypes = propTypes;

export default LoginSSOPage;
